import   React          ,
       { useState       ,
         useEffect      ,
         useRef         }  from 'react';

import   classNames        from 'classnames';

import   styles            from './AdSpotSelector.module.scss';

import { AdSpot         }  from '../../../dataTypes/mediaManagment/adSpot_types';

import { LegalStructure }  from '../../../dataTypes/legalStructureManagment/types';

import { convertDateToString }  from '../../../dataTypes/timeManagment/utils';

import   Select            from '../../widget/inputs/Select';
import   Field             from '../../widget/inputs/Field';
import   Icon              from '../../widget/images/Icon';
import   Trigger           from '../../widget/actuators/Trigger';

import   AdSpotSheet        from './AdSpotSheet';

import { WWW_URLS       }  from '../../../backendServices/urls';

export interface AdSpotSelectorProps {
  onCancel?        : () => void | null;
  onSelect?        : (id: number) => void | null;
  adSpotSet?       : AdSpot[];
  legalStructure?  : LegalStructure;
  thumbnailWidth?  : number;  // Largeur de la vignette (par défaut 300)
  thumbnailHeight? : number; // Hauteur de la vignette (par défaut 170)
  componentWidth?  : number;  // Largeur du composant (par défaut 972)
  componentHeight? : number; // Hauteur du composant (par défaut 626)
  originalFilter?  : string[];
}

export const AdSpotSelector = ({ onCancel               ,
                                 onSelect               ,
                                 adSpotSet              ,
                                 legalStructure         ,
                                 thumbnailWidth  =  300 ,
                                 thumbnailHeight =  170 ,
                                 componentWidth  = 1210 ,
                                 componentHeight =  626 ,
						         originalFilter  = []   }: AdSpotSelectorProps) => {

  const [ filteredAdSpotSet              ] = useState<AdSpot[]>(adSpotSet ?? []);
  const [ selectedSortingCriteria , setSelectedSortingCriteria        ] = useState('Aucun tri');
  const [ filter                  , setFilter                         ] = useState('');
  const [ showCreateWindow        , setShowCreateWindow               ] = useState(false);


  const creationWindowRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (showCreateWindow && creationWindowRef.current) {
      creationWindowRef.current.scrollTop = 0;
    }
  }, [showCreateWindow]);

  const handleClick = (adSpotId: number) => {

    if (onSelect) {
      onSelect(adSpotId);
    }
  };

  const renderAdSpotThumbnail = (adSpot?: AdSpot): JSX.Element => {

    let durationStr = adSpot ? ((adSpot as AdSpot).duration) : ''

    let ch          = adSpot ? convertDateToString (adSpot.creationDate, 'dd/MM/yyyy') : '' ;

    ch += ( ( ch !== '' && durationStr !== '' ) ? ' / ' : '') + durationStr

    return (
      <div className = {classNames(styles.thumbnail)}
           onClick   = {adSpot ? () => handleClick(adSpot.id) : undefined}
           style     = {{ width: thumbnailWidth, height: thumbnailHeight + 100 }} >

        {
         adSpot &&
         (
          <>
            <div className = {classNames(styles.line_1)}>
              <img src   = {`${WWW_URLS.Thumbnail}${adSpot.thumbnail}.webp`}
                   alt   = {adSpot.name}
                   style = {{ width: thumbnailWidth, height: thumbnailHeight }} />
            </div>
            <div className={classNames(styles.line_2, styles.text)}>
              <>{adSpot.name} ({ch}) </>
            </div>
          </>
         )
        }
      </div>
    );
  };

  const renderAdSpotThumbnailsList = (): JSX.Element => {

    const thumbnailsPerRow = Math.floor(componentWidth / thumbnailWidth);
    const rows: JSX.Element[] = [];

    for (let i = 0; i < filteredAdSpotSet.length; i += thumbnailsPerRow)
     {
      const rowAdSpots   = filteredAdSpotSet.slice(i, i + thumbnailsPerRow);
      const emptyColumns = thumbnailsPerRow - rowAdSpots.length;

      rows.push
       (
        <div key={`row-${i}`} className={classNames(styles.row)}>
         {
          rowAdSpots.map((adSpot) =>
           (
            <div key={adSpot.id} className={classNames(styles.column)}>
              {renderAdSpotThumbnail(adSpot)}
            </div>
           )
          )
         }

         {/* Ajouter des éléments vides pour compléter la dernière ligne */}
         {
          Array.from({ length: emptyColumns }).map((_, index) =>
           (
            <div key={`empty-${i}-${index}`} className={classNames(styles.column)}>
             {renderAdSpotThumbnail()}
            </div>
           )
          )
         }
        </div>
       );
     }

    return <div className={classNames(styles.adSpot_grid)}>{rows}</div>;
  };




  const handleSortingCriteriaChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedSortingCriteria(e.target.value);
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.value);
  };

  const renderSortingCriteria = (): JSX.Element => {
    const sortingCriteriaNames = [
      'Aucun tri',
      'Par date de sortie croissante',
      'Par date de sortie décroissante',
      'Par durée croissante',
      'Par durée décroissante'
    ];

    return (
      <Select choices  = {sortingCriteriaNames}
              value    = {selectedSortingCriteria}
              onChange = {handleSortingCriteriaChange} />
    );
  };

  const handleCloseButtonClick = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const handleCreationWindowShow = () => {
    setShowCreateWindow(true);
  };

  const handleCreationWindowCancel = () => {
    setShowCreateWindow(false);
  };


  const handleMediaCreate = (id:number) => {

      setShowCreateWindow (false)
  }

  return (
    <div className = {classNames(styles.root)}
         style     = {{ width: componentWidth, height: componentHeight }} >

      {showCreateWindow && (<AdSpotSheet onClose ={handleCreationWindowCancel} onCreate={handleMediaCreate} />)}

      {/* Croix de fermeture en dehors de search_bar */}
      <div className={classNames(styles.close_button)}>
        <Icon name       = "cross"
              onClick    = {handleCloseButtonClick}
              color      = "#000000"
              hoverColor = "#FFFF00" />
      </div>

      {/* Barre de recherche décalée vers le bas */}
      <div className={classNames(styles.upper_bar)}>

        {renderSortingCriteria()}
        <Field type        = "text"
               placeholder = "Filtrer par titre"
               value       = {filter}
               onChange    = {handleFilterChange} />
        <div className={classNames(styles.adSpotCreationButton)}>
          <Trigger name    = "Créer un spot"
                   onClick = {handleCreationWindowShow}
                   variant = "tailwind2" />
        </div>
      </div>

      <div className={classNames(styles.adSpot_grid)}>
        {renderAdSpotThumbnailsList()}
      </div>
    </div>
  );
};

export default AdSpotSelector;
